import React, { useState, useRef, useEffect } from 'react';
import './MeasroDashboard.css';

const ReportLeftData = ({ property, toggleVisibility, toggleUnit, onOpacityChange, onColorChange  }) => {
    const [showOpacityModal, setShowOpacityModal] = useState(false);
    const modalRef = useRef(null);


    // console.log('ReportLeftData property:', property);
    // console.log('ReportLeftData toggleVisibility:', toggleVisibility);
    // console.log('ReportLeftData toggleUnit:', toggleUnit);
    // console.log('ReportLeftData onOpacityChange:', onOpacityChange);
    // console.log('ReportLeftData onColorChange:', onColorChange);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                setShowOpacityModal(false);
            }
        };
        if (showOpacityModal) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showOpacityModal]);

    if (!property) return null;

    // Standard conversion factor: 1 Acre = 43,560 Square Feet
    const SQFT_PER_ACRE = 43560;
    // const SQFT_PER_ACRE = 4046.86;
    


    // Logic to calculate values based on what is provided in the property object
    // If you have sqft, calculate acres. If you only have acres, calculate sqft.
    const displaySqft = property.sqft || (property.acre * SQFT_PER_ACRE) || 0;
    const displayAcre = property.acre || (property.sqft / SQFT_PER_ACRE) || 0;

    return (
        <> 
            <div className="panel-title">
                <i className="fas fa-info-circle"></i> Feature Coverage
            </div>

            <div className="lot-area-compact">
                <div className="lot-area-row">
                    <div className="lot-left">
                       <div className="lot-color-box" style={{ background: property.color, position: 'relative', cursor: 'pointer' }}>
    <input
        type="color"
        value={property.color}
        onChange={(e) => onColorChange(e.target.value)}
        style={{ opacity: 0, position: 'absolute', inset: 0, cursor: 'pointer', width: '100%', height: '100%' }}
    />
</div>


                        <div className="lot-label">{property.name}</div>
                    </div>
                    <div className="lot-right">
                        <div className="lot-value">
                            <span>
  {property.unit === 'sqft' 
    ? displaySqft.toLocaleString(undefined, { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      }) 
    : displayAcre.toLocaleString(undefined, { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}
</span>
                            <span className="unit"> {property.unit === 'sqft' ? 'sq ft' : 'acre'}</span>
                            <button 
                                className="unit-toggle" 
                                onClick={toggleUnit} 
                                title={`Switch to ${property.unit === 'sqft' ? 'Acres' : 'Sq Ft'}`}
                            >
                                <i className="fas fa-exchange-alt"></i>
                            </button>
                        </div>

                        <button
                            className="eye-toggle-small"
                            onClick={() => setShowOpacityModal(true)}
                            title="Adjust fill opacity"
                        >
                            <i className="fas fa-fill-drip"></i>
                        </button>

                        <button 
                            className={`eye-toggle-small ${property.visible ? 'active' : ''}`} 
                            onClick={toggleVisibility}
                        >
                            <i className={`fas ${property.visible ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                        </button>
                    </div>
                </div>
            </div>

            {showOpacityModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: 'rgba(0,0,0,0.4)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10000
                    }}
                >
                    <div
                        ref={modalRef}
                        style={{
                            background: '#fff',
                            borderRadius: '10px',
                            padding: '20px 24px',
                            width: '300px',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                            <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>
                                <i className="fas fa-fill-drip" style={{ marginRight: '8px', color: property.color }}></i>
                                Parcel Fill Opacity
                            </div>
                            <button
                                onClick={() => setShowOpacityModal(false)}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1rem', color: '#888' }}
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.05"
                                value={property.fillOpacity ?? 0}
                                onChange={(e) => onOpacityChange(parseFloat(e.target.value))}
                                style={{ flex: 1 }}
                            />
                            <span style={{ fontSize: '0.8rem', color: '#666', minWidth: '36px', textAlign: 'right' }}>
                                {Math.round((property.fillOpacity ?? 0) * 100)}%
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ReportLeftData;